import ResetCode from "../../components/Password/ResetCode";

const ResetCodePage = () => {
  return <ResetCode />;
};

export default ResetCodePage;
